import {TFunction} from 'i18next'
import moment from 'moment-timezone'

export const formatMonthYear = (date: string, t: TFunction) => {
  const month = moment.utc(date).get('month')
  const year = moment.utc(date).get('year')
  const monthText = t('datePicker.months', {returnObjects: true})[month]

  return `${monthText} ${year}`
}
